
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("e93q4", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardInternal", () => $870c7bdfaace1ea1$export$396f5f2a61633d22);
$parcel$export(module.exports, "MediaInlineCard", () => $870c7bdfaace1ea1$export$df41e610fec60a75);

var $2OMIu = parcelRequire("2OMIu");

var $12d8n = parcelRequire("12d8n");

var $ibc0O = parcelRequire("ibc0O");
var $iviFJ = parcelRequire("iviFJ");

var $2tyFY = parcelRequire("2tyFY");
var $jTK8A = parcelRequire("jTK8A");
var $g7R6J = parcelRequire("g7R6J");
var $4Vfxk = parcelRequire("4Vfxk");

var $hXEj5 = parcelRequire("hXEj5");

var $8LhoW = parcelRequire("8LhoW");

var $bdHts = parcelRequire("bdHts");

var $adetW = parcelRequire("adetW");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $i5FdW = parcelRequire("i5FdW");
var $8RXs9 = parcelRequire("8RXs9");

var $kAmKx = parcelRequire("kAmKx");

var $84J7p = parcelRequire("84J7p");

var $8BpTo = parcelRequire("8BpTo");

var $EEbRM = parcelRequire("EEbRM");
const $870c7bdfaace1ea1$export$396f5f2a61633d22 = ({ mediaClient: mediaClient, identifier: identifier, shouldOpenMediaViewer: shouldOpenMediaViewer, shouldDisplayToolTip: shouldDisplayToolTip, isSelected: isSelected, onClick: onClick, mediaViewerItems: mediaViewerItems, intl: intl, viewerOptions: viewerOptions })=>{
    const [fileState, setFileState] = (0, $5uXOq.useState)();
    const [subscribeError, setSubscribeError] = (0, $5uXOq.useState)();
    const [isSucceededEventSent, setIsSucceededEventSent] = (0, $5uXOq.useState)(false);
    const [isFailedEventSent, setIsFailedEventSent] = (0, $5uXOq.useState)(false);
    const [isMediaViewerVisible, setMediaViewerVisible] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const fireFailedOperationalEvent = (error = new (0, $kAmKx.MediaCardError)('missing-error-data'), failReason)=>{
        const payload = failReason ? (0, $8BpTo.getFailedProcessingStatusPayload)(identifier.id, fileState) : (0, $8BpTo.getErrorStatusPayload)(identifier.id, error, fileState);
        setIsFailedEventSent(true);
        (0, $84J7p.fireMediaCardEvent)(payload, createAnalyticsEvent);
    };
    const fireSucceededOperationalEvent = ()=>{
        const payload = (0, $8BpTo.getSucceededStatusPayload)(fileState);
        setIsSucceededEventSent(true);
        (0, $84J7p.fireMediaCardEvent)(payload, createAnalyticsEvent);
    };
    const { copyNodeRef: copyNodeRef } = (0, $EEbRM.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    const onMediaInlineCardClick = (event)=>{
        if (onClick) {
            const inlineCardEvent = {
                event: event,
                mediaItemDetails: identifier
            };
            onClick(inlineCardEvent);
        }
        if (shouldOpenMediaViewer) setMediaViewerVisible(true);
    };
    const onMediaViewerClose = ()=>setMediaViewerVisible(false);
    const renderMediaViewer = ()=>{
        if (isMediaViewerVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdHts.default), {
            collectionName: identifier.collectionName || '',
            items: mediaViewerItems || [],
            mediaClientConfig: mediaClient.mediaClientConfig,
            selectedItem: identifier,
            onClose: onMediaViewerClose,
            viewerOptions: viewerOptions
        }), document.body);
        return null;
    };
    const renderContent = (children)=>{
        return intl ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: children
        });
    };
    const defaultIntl = (0, $i5FdW.createIntl)({
        locale: 'en'
    });
    (0, $5uXOq.useEffect)(()=>{
        const subscription = mediaClient.file.getFileState(identifier.id, {
            collectionName: identifier.collectionName
        }).subscribe({
            next: (fileState)=>{
                setFileState(fileState);
                setSubscribeError(undefined);
            },
            error: (e)=>{
                setSubscribeError(e);
            }
        });
        return ()=>{
            subscription?.unsubscribe();
        };
    }, [
        identifier.collectionName,
        identifier.id,
        mediaClient.file
    ]);
    if (subscribeError) {
        const errorMessage = fileState?.status === 'uploading' ? (0, $4Vfxk.messages).failed_to_upload : (0, $4Vfxk.messages).couldnt_load_file;
        const errorReason = fileState?.status === 'uploading' ? 'upload' : 'metadata-fetch';
        !isFailedEventSent && fireFailedOperationalEvent(new (0, $kAmKx.MediaCardError)(errorReason, subscribeError));
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tyFY.MediaInlineCardErroredView), {
            innerRef: copyNodeRef,
            message: (intl || defaultIntl).formatMessage(errorMessage),
            isSelected: isSelected
        });
    }
    if (fileState?.status === 'error') {
        const error = new (0, $kAmKx.MediaCardError)('error-file-state', (0, $iviFJ.toCommonMediaClientError)(fileState));
        !isFailedEventSent && fireFailedOperationalEvent(error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tyFY.MediaInlineCardErroredView), {
            innerRef: copyNodeRef,
            message: (intl || defaultIntl).formatMessage((0, $4Vfxk.messages).couldnt_load_file),
            isSelected: isSelected
        });
    }
    // Empty file handling
    if (fileState && !fileState.name) {
        const error = new (0, $kAmKx.MediaCardError)('metadata-fetch', new (0, $ibc0O.FileFetcherError)('emptyFileName', {
            id: fileState.id
        }));
        !isFailedEventSent && fireFailedOperationalEvent(error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2tyFY.MediaInlineCardErroredView), {
            innerRef: copyNodeRef,
            message: (intl || defaultIntl).formatMessage((0, $4Vfxk.messages).couldnt_load_file),
            isSelected: isSelected
        });
    }
    if (fileState?.status === 'uploading') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g7R6J.MediaInlineCardLoadingView), {
        innerRef: copyNodeRef,
        message: fileState.name,
        isSelected: isSelected
    });
    if (!fileState) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g7R6J.MediaInlineCardLoadingView), {
        innerRef: copyNodeRef,
        message: (intl || defaultIntl).formatMessage((0, $4Vfxk.messages).loading_file),
        isSelected: isSelected
    });
    // Failed to process should still display the loaded view and enable Media Client to download
    if (fileState?.status === 'failed-processing') !isFailedEventSent && fireFailedOperationalEvent(undefined, 'failed-processing');
    const { mediaType: mediaType, name: name, mimeType: mimeType } = fileState;
    const linkIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8LhoW.MimeTypeIcon), {
        testId: 'media-inline-card-file-type-icon',
        size: "small",
        mediaType: mediaType,
        mimeType: mimeType,
        name: name
    });
    const mediaViewer = renderMediaViewer();
    let formattedDate;
    if (fileState.createdAt) {
        const { locale: locale = 'en' } = intl || {
            locale: 'en'
        };
        formattedDate = (0, $hXEj5.formatDate)(fileState.createdAt, locale);
    }
    if (fileState.status === 'processed' && !isSucceededEventSent) fireSucceededOperationalEvent();
    if (shouldDisplayToolTip === undefined || shouldDisplayToolTip === true) return renderContent(/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $adetW.default), {
                position: "bottom",
                content: formattedDate,
                tag: "span",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jTK8A.MediaInlineCardLoadedView), {
                    innerRef: copyNodeRef,
                    icon: linkIcon,
                    title: name,
                    onClick: onMediaInlineCardClick,
                    isSelected: isSelected
                })
            }),
            mediaViewer
        ]
    }));
    else return renderContent(/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jTK8A.MediaInlineCardLoadedView), {
                innerRef: copyNodeRef,
                icon: linkIcon,
                title: name,
                onClick: onMediaInlineCardClick,
                isSelected: isSelected
            }),
            mediaViewer
        ]
    }));
};
const $870c7bdfaace1ea1$export$df41e610fec60a75 = (0, $8RXs9.default)($870c7bdfaace1ea1$export$396f5f2a61633d22, {
    enforceContext: false
});

});
parcelRegister("2tyFY", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardErroredView", () => $399fbacbe85eb1b2$export$2d2af0bb1fae5ada);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $e8nxS = parcelRequire("e8nxS");

var $abeia = parcelRequire("abeia");

var $j8xxK = parcelRequire("j8xxK");

var $1XY6L = parcelRequire("1XY6L");

var $fbiH2 = parcelRequire("fbiH2");
class $399fbacbe85eb1b2$export$2d2af0bb1fae5ada extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { onClick: onClick, isSelected: isSelected, innerRef: innerRef, testId: testId = 'media-inline-card-errored-view', icon: icon } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abeia.Frame), {
            testId: testId,
            innerRef: innerRef,
            onClick: onClick,
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j8xxK.IconAndTitleLayout), {
                icon: icon || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1XY6L.AKIconWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8nxS))), {
                        label: "error",
                        LEGACY_size: "small",
                        color: `var(--ds-icon-danger, ${(0, $4f06f72592355b39$export$4a7404f376229999)})`
                    })
                }),
                title: this.renderMessage()
            })
        });
    }
    constructor(...args){
        super(...args), this.renderMessage = ()=>{
            const { message: message } = this.props;
            const errorMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fbiH2.NoLinkAppearance), {
                children: message
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                children: errorMessage
            });
        };
    }
}

});
var $4f06f72592355b39$exports = {};

$parcel$export($4f06f72592355b39$exports, "R50", () => $4f06f72592355b39$export$4b84fd0e2c617bd);
$parcel$export($4f06f72592355b39$exports, "R75", () => $4f06f72592355b39$export$b34b069eff244586);
$parcel$export($4f06f72592355b39$exports, "R100", () => $4f06f72592355b39$export$be802dd0d8b57f35);
$parcel$export($4f06f72592355b39$exports, "R200", () => $4f06f72592355b39$export$60847d42f9da92a6);
$parcel$export($4f06f72592355b39$exports, "R300", () => $4f06f72592355b39$export$4a7404f376229999);
$parcel$export($4f06f72592355b39$exports, "R400", () => $4f06f72592355b39$export$2010d0fb4295b346);
$parcel$export($4f06f72592355b39$exports, "R500", () => $4f06f72592355b39$export$2837b5a1a71d5c02);
$parcel$export($4f06f72592355b39$exports, "Y50", () => $4f06f72592355b39$export$8d9596b529bbb9cf);
$parcel$export($4f06f72592355b39$exports, "Y75", () => $4f06f72592355b39$export$41060a744ab0b7ae);
$parcel$export($4f06f72592355b39$exports, "Y100", () => $4f06f72592355b39$export$1cc05bbbf340e559);
$parcel$export($4f06f72592355b39$exports, "Y200", () => $4f06f72592355b39$export$5aae31392d72caaa);
$parcel$export($4f06f72592355b39$exports, "Y300", () => $4f06f72592355b39$export$c6930421db9fa514);
$parcel$export($4f06f72592355b39$exports, "Y400", () => $4f06f72592355b39$export$59619663aa6500fb);
$parcel$export($4f06f72592355b39$exports, "Y500", () => $4f06f72592355b39$export$874739ea9e379ab6);
$parcel$export($4f06f72592355b39$exports, "G50", () => $4f06f72592355b39$export$8a6341c32b6a3ee6);
$parcel$export($4f06f72592355b39$exports, "G75", () => $4f06f72592355b39$export$69a3bf21b9686c2b);
$parcel$export($4f06f72592355b39$exports, "G100", () => $4f06f72592355b39$export$afbce1382ec95f73);
$parcel$export($4f06f72592355b39$exports, "G200", () => $4f06f72592355b39$export$747d86715d4175de);
$parcel$export($4f06f72592355b39$exports, "G300", () => $4f06f72592355b39$export$940e1f69e873f202);
$parcel$export($4f06f72592355b39$exports, "G400", () => $4f06f72592355b39$export$a49394138f7b8e85);
$parcel$export($4f06f72592355b39$exports, "G500", () => $4f06f72592355b39$export$6fa04827ac68a4fb);
$parcel$export($4f06f72592355b39$exports, "B50", () => $4f06f72592355b39$export$226de0355ed012f8);
$parcel$export($4f06f72592355b39$exports, "B75", () => $4f06f72592355b39$export$8c13c2ee36917869);
$parcel$export($4f06f72592355b39$exports, "B100", () => $4f06f72592355b39$export$ecfc1dff386a3e7a);
$parcel$export($4f06f72592355b39$exports, "B200", () => $4f06f72592355b39$export$215b7063051591f1);
$parcel$export($4f06f72592355b39$exports, "B300", () => $4f06f72592355b39$export$e62e8919cca44969);
$parcel$export($4f06f72592355b39$exports, "B400", () => $4f06f72592355b39$export$b3de0ae08da2ce64);
$parcel$export($4f06f72592355b39$exports, "B500", () => $4f06f72592355b39$export$a6ee3d71bc067634);
$parcel$export($4f06f72592355b39$exports, "B600", () => $4f06f72592355b39$export$67f15409e87642a1);
$parcel$export($4f06f72592355b39$exports, "B700", () => $4f06f72592355b39$export$f0539dbc42dbb067);
$parcel$export($4f06f72592355b39$exports, "P50", () => $4f06f72592355b39$export$363e4475840015bb);
$parcel$export($4f06f72592355b39$exports, "P75", () => $4f06f72592355b39$export$4b0a4417ed59760f);
$parcel$export($4f06f72592355b39$exports, "P100", () => $4f06f72592355b39$export$6011520a64d9a187);
$parcel$export($4f06f72592355b39$exports, "P200", () => $4f06f72592355b39$export$a7175d4e9206bc80);
$parcel$export($4f06f72592355b39$exports, "P300", () => $4f06f72592355b39$export$b48405b95304b5a1);
$parcel$export($4f06f72592355b39$exports, "P400", () => $4f06f72592355b39$export$c71e4279dd54a18d);
$parcel$export($4f06f72592355b39$exports, "P500", () => $4f06f72592355b39$export$147899de772240ec);
$parcel$export($4f06f72592355b39$exports, "T50", () => $4f06f72592355b39$export$2cf711fe14c66f06);
$parcel$export($4f06f72592355b39$exports, "T75", () => $4f06f72592355b39$export$7a8f4d33f6f9772c);
$parcel$export($4f06f72592355b39$exports, "T100", () => $4f06f72592355b39$export$776c9c497ef08533);
$parcel$export($4f06f72592355b39$exports, "T200", () => $4f06f72592355b39$export$69cb3ca10c1e330e);
$parcel$export($4f06f72592355b39$exports, "T300", () => $4f06f72592355b39$export$9dc1ef0f3f48059b);
$parcel$export($4f06f72592355b39$exports, "T400", () => $4f06f72592355b39$export$7c835c78b6fcdef8);
$parcel$export($4f06f72592355b39$exports, "T500", () => $4f06f72592355b39$export$6036577f95c3877e);
$parcel$export($4f06f72592355b39$exports, "N0", () => $4f06f72592355b39$export$29a4f05edc054374);
$parcel$export($4f06f72592355b39$exports, "N10", () => $4f06f72592355b39$export$e655ef011c4aa1a2);
$parcel$export($4f06f72592355b39$exports, "N20", () => $4f06f72592355b39$export$9fdfb749e33cdf97);
$parcel$export($4f06f72592355b39$exports, "N30", () => $4f06f72592355b39$export$3e51e8f1440314ba);
$parcel$export($4f06f72592355b39$exports, "N40", () => $4f06f72592355b39$export$1ce2d1575d444ceb);
$parcel$export($4f06f72592355b39$exports, "N50", () => $4f06f72592355b39$export$8754fc7e6d8b3000);
$parcel$export($4f06f72592355b39$exports, "N60", () => $4f06f72592355b39$export$c2e91cbeada39b8b);
$parcel$export($4f06f72592355b39$exports, "N70", () => $4f06f72592355b39$export$5f71e19f3a7ad9de);
$parcel$export($4f06f72592355b39$exports, "N80", () => $4f06f72592355b39$export$eaa8c8a70ac22806);
$parcel$export($4f06f72592355b39$exports, "N90", () => $4f06f72592355b39$export$7c87d337fb91a97d);
$parcel$export($4f06f72592355b39$exports, "N100", () => $4f06f72592355b39$export$d6447c357493214f);
$parcel$export($4f06f72592355b39$exports, "N200", () => $4f06f72592355b39$export$f563ee71e9ee74cd);
$parcel$export($4f06f72592355b39$exports, "N300", () => $4f06f72592355b39$export$e2ef2124cf4024b1);
$parcel$export($4f06f72592355b39$exports, "N400", () => $4f06f72592355b39$export$eece5f492e429f08);
$parcel$export($4f06f72592355b39$exports, "N500", () => $4f06f72592355b39$export$c39c0fe0f26207ae);
$parcel$export($4f06f72592355b39$exports, "N600", () => $4f06f72592355b39$export$7090862dc3038a9f);
$parcel$export($4f06f72592355b39$exports, "N700", () => $4f06f72592355b39$export$ad0bacf983b7ddaa);
$parcel$export($4f06f72592355b39$exports, "N800", () => $4f06f72592355b39$export$7d61b15e0da132af);
$parcel$export($4f06f72592355b39$exports, "N900", () => $4f06f72592355b39$export$fbda843f0a27fe96);
$parcel$export($4f06f72592355b39$exports, "N10A", () => $4f06f72592355b39$export$791e57b27ca738ef);
$parcel$export($4f06f72592355b39$exports, "N20A", () => $4f06f72592355b39$export$8d43898f60b96a82);
$parcel$export($4f06f72592355b39$exports, "N30A", () => $4f06f72592355b39$export$920c0d5c49070351);
$parcel$export($4f06f72592355b39$exports, "N40A", () => $4f06f72592355b39$export$46987b49aab6d1a8);
$parcel$export($4f06f72592355b39$exports, "N50A", () => $4f06f72592355b39$export$7d3359664e8bb0e5);
$parcel$export($4f06f72592355b39$exports, "N60A", () => $4f06f72592355b39$export$d2d3bedfb276cac0);
$parcel$export($4f06f72592355b39$exports, "N70A", () => $4f06f72592355b39$export$6e5e7499ff054f6d);
$parcel$export($4f06f72592355b39$exports, "N80A", () => $4f06f72592355b39$export$59264b346c877fa7);
$parcel$export($4f06f72592355b39$exports, "N90A", () => $4f06f72592355b39$export$d092757d7c64925c);
$parcel$export($4f06f72592355b39$exports, "N100A", () => $4f06f72592355b39$export$486ab785e4bac3c6);
$parcel$export($4f06f72592355b39$exports, "N200A", () => $4f06f72592355b39$export$fba592bbc6419fea);
$parcel$export($4f06f72592355b39$exports, "N300A", () => $4f06f72592355b39$export$13609db0e6812ab8);
$parcel$export($4f06f72592355b39$exports, "N400A", () => $4f06f72592355b39$export$fbae4efaa892d883);
$parcel$export($4f06f72592355b39$exports, "N500A", () => $4f06f72592355b39$export$f13946d26f440ce6);
$parcel$export($4f06f72592355b39$exports, "N600A", () => $4f06f72592355b39$export$19f58225ac52a306);
$parcel$export($4f06f72592355b39$exports, "N700A", () => $4f06f72592355b39$export$6384f09da70e7b62);
$parcel$export($4f06f72592355b39$exports, "N800A", () => $4f06f72592355b39$export$d0dccc730683edc2);
$parcel$export($4f06f72592355b39$exports, "DN900", () => $4f06f72592355b39$export$2f6319cf7d736c2a);
$parcel$export($4f06f72592355b39$exports, "DN800", () => $4f06f72592355b39$export$95126bc8884d6634);
$parcel$export($4f06f72592355b39$exports, "DN700", () => $4f06f72592355b39$export$8338d8c35d44ff1);
$parcel$export($4f06f72592355b39$exports, "DN600", () => $4f06f72592355b39$export$5368d76ae4fbbda7);
$parcel$export($4f06f72592355b39$exports, "DN500", () => $4f06f72592355b39$export$9f0a771d16ec8d36);
$parcel$export($4f06f72592355b39$exports, "DN400", () => $4f06f72592355b39$export$abcf8c38338b4aa5);
$parcel$export($4f06f72592355b39$exports, "DN300", () => $4f06f72592355b39$export$97e81faa16a182c7);
$parcel$export($4f06f72592355b39$exports, "DN200", () => $4f06f72592355b39$export$bfe21c59123ecf33);
$parcel$export($4f06f72592355b39$exports, "DN100", () => $4f06f72592355b39$export$ee82aa2ea6a1558);
$parcel$export($4f06f72592355b39$exports, "DN90", () => $4f06f72592355b39$export$682927c6ed76be02);
$parcel$export($4f06f72592355b39$exports, "DN80", () => $4f06f72592355b39$export$91fd9994c5be9757);
$parcel$export($4f06f72592355b39$exports, "DN70", () => $4f06f72592355b39$export$d281fbfe3cff2df6);
$parcel$export($4f06f72592355b39$exports, "DN60", () => $4f06f72592355b39$export$3902c91d8b98a753);
$parcel$export($4f06f72592355b39$exports, "DN50", () => $4f06f72592355b39$export$8e8133c1ba5845b5);
$parcel$export($4f06f72592355b39$exports, "DN40", () => $4f06f72592355b39$export$33ff357f6620b39);
$parcel$export($4f06f72592355b39$exports, "DN30", () => $4f06f72592355b39$export$633847cf062b69e0);
$parcel$export($4f06f72592355b39$exports, "DN20", () => $4f06f72592355b39$export$9776a6e503bdbf76);
$parcel$export($4f06f72592355b39$exports, "DN10", () => $4f06f72592355b39$export$6c813d5160dff5db);
$parcel$export($4f06f72592355b39$exports, "DN0", () => $4f06f72592355b39$export$3d4f271a500072a);
$parcel$export($4f06f72592355b39$exports, "DN800A", () => $4f06f72592355b39$export$fe151285c22759ec);
$parcel$export($4f06f72592355b39$exports, "DN700A", () => $4f06f72592355b39$export$a101c6190d0da34);
$parcel$export($4f06f72592355b39$exports, "DN600A", () => $4f06f72592355b39$export$4b16f52932fda51);
$parcel$export($4f06f72592355b39$exports, "DN500A", () => $4f06f72592355b39$export$a74bcd7b9845b0d8);
$parcel$export($4f06f72592355b39$exports, "DN400A", () => $4f06f72592355b39$export$9209c179316d1751);
$parcel$export($4f06f72592355b39$exports, "DN300A", () => $4f06f72592355b39$export$88f55133f636c8dd);
$parcel$export($4f06f72592355b39$exports, "DN200A", () => $4f06f72592355b39$export$51126f85d1009512);
$parcel$export($4f06f72592355b39$exports, "DN100A", () => $4f06f72592355b39$export$a069b547bd23af78);
$parcel$export($4f06f72592355b39$exports, "DN90A", () => $4f06f72592355b39$export$40cce05af3b2600a);
$parcel$export($4f06f72592355b39$exports, "DN80A", () => $4f06f72592355b39$export$b78942185925a0d);
$parcel$export($4f06f72592355b39$exports, "DN70A", () => $4f06f72592355b39$export$e058fb44b8eaafca);
$parcel$export($4f06f72592355b39$exports, "DN60A", () => $4f06f72592355b39$export$92b0b8de26920c18);
$parcel$export($4f06f72592355b39$exports, "DN50A", () => $4f06f72592355b39$export$67564f7459d3fc9e);
$parcel$export($4f06f72592355b39$exports, "DN40A", () => $4f06f72592355b39$export$77868e1ca884ffa3);
$parcel$export($4f06f72592355b39$exports, "DN30A", () => $4f06f72592355b39$export$2afd71d7d3ea2cd5);
$parcel$export($4f06f72592355b39$exports, "DN20A", () => $4f06f72592355b39$export$f2a0acaab9972c70);
$parcel$export($4f06f72592355b39$exports, "DN10A", () => $4f06f72592355b39$export$9ab70e67d6475361);
$parcel$export($4f06f72592355b39$exports, "T30", () => $4f06f72592355b39$export$d2adc5dedf09fced);
$parcel$export($4f06f72592355b39$exports, "L50", () => $4f06f72592355b39$export$f51762073d2bb381);
$parcel$export($4f06f72592355b39$exports, "L75", () => $4f06f72592355b39$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $4f06f72592355b39$export$4b84fd0e2c617bd = '#FFEBE6';
const $4f06f72592355b39$export$b34b069eff244586 = '#FFBDAD';
const $4f06f72592355b39$export$be802dd0d8b57f35 = '#FF8F73';
const $4f06f72592355b39$export$60847d42f9da92a6 = '#FF7452';
const $4f06f72592355b39$export$4a7404f376229999 = '#FF5630';
const $4f06f72592355b39$export$2010d0fb4295b346 = '#DE350B';
const $4f06f72592355b39$export$2837b5a1a71d5c02 = '#BF2600';
const $4f06f72592355b39$export$8d9596b529bbb9cf = '#FFFAE6';
const $4f06f72592355b39$export$41060a744ab0b7ae = '#FFF0B3';
const $4f06f72592355b39$export$1cc05bbbf340e559 = '#FFE380';
const $4f06f72592355b39$export$5aae31392d72caaa = '#FFC400';
const $4f06f72592355b39$export$c6930421db9fa514 = '#FFAB00';
const $4f06f72592355b39$export$59619663aa6500fb = '#FF991F';
const $4f06f72592355b39$export$874739ea9e379ab6 = '#FF8B00';
const $4f06f72592355b39$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $4f06f72592355b39$export$69a3bf21b9686c2b = '#ABF5D1';
const $4f06f72592355b39$export$afbce1382ec95f73 = '#79F2C0';
const $4f06f72592355b39$export$747d86715d4175de = '#57D9A3';
const $4f06f72592355b39$export$940e1f69e873f202 = '#36B37E';
const $4f06f72592355b39$export$a49394138f7b8e85 = '#00875A';
const $4f06f72592355b39$export$6fa04827ac68a4fb = '#006644';
const $4f06f72592355b39$export$226de0355ed012f8 = '#DEEBFF';
const $4f06f72592355b39$export$8c13c2ee36917869 = '#B3D4FF';
const $4f06f72592355b39$export$ecfc1dff386a3e7a = '#4C9AFF';
const $4f06f72592355b39$export$215b7063051591f1 = '#2684FF';
const $4f06f72592355b39$export$e62e8919cca44969 = '#0065FF';
const $4f06f72592355b39$export$b3de0ae08da2ce64 = '#0052CC';
const $4f06f72592355b39$export$a6ee3d71bc067634 = '#0747A6';
const $4f06f72592355b39$export$67f15409e87642a1 = '#669DF1';
const $4f06f72592355b39$export$f0539dbc42dbb067 = '#8FB8F6';
const $4f06f72592355b39$export$363e4475840015bb = '#EAE6FF';
const $4f06f72592355b39$export$4b0a4417ed59760f = '#C0B6F2';
const $4f06f72592355b39$export$6011520a64d9a187 = '#998DD9';
const $4f06f72592355b39$export$a7175d4e9206bc80 = '#8777D9';
const $4f06f72592355b39$export$b48405b95304b5a1 = '#6554C0';
const $4f06f72592355b39$export$c71e4279dd54a18d = '#5243AA';
const $4f06f72592355b39$export$147899de772240ec = '#403294';
const $4f06f72592355b39$export$2cf711fe14c66f06 = '#E6FCFF';
const $4f06f72592355b39$export$7a8f4d33f6f9772c = '#B3F5FF';
const $4f06f72592355b39$export$776c9c497ef08533 = '#79E2F2';
const $4f06f72592355b39$export$69cb3ca10c1e330e = '#00C7E6';
const $4f06f72592355b39$export$9dc1ef0f3f48059b = '#00B8D9';
const $4f06f72592355b39$export$7c835c78b6fcdef8 = '#00A3BF';
const $4f06f72592355b39$export$6036577f95c3877e = '#008DA6';
const $4f06f72592355b39$export$29a4f05edc054374 = '#FFFFFF';
const $4f06f72592355b39$export$e655ef011c4aa1a2 = '#FAFBFC';
const $4f06f72592355b39$export$9fdfb749e33cdf97 = '#F4F5F7';
const $4f06f72592355b39$export$3e51e8f1440314ba = '#EBECF0';
const $4f06f72592355b39$export$1ce2d1575d444ceb = '#DFE1E6';
const $4f06f72592355b39$export$8754fc7e6d8b3000 = '#C1C7D0';
const $4f06f72592355b39$export$c2e91cbeada39b8b = '#B3BAC5';
const $4f06f72592355b39$export$5f71e19f3a7ad9de = '#A5ADBA';
const $4f06f72592355b39$export$eaa8c8a70ac22806 = '#97A0AF';
const $4f06f72592355b39$export$7c87d337fb91a97d = '#8993A4';
const $4f06f72592355b39$export$d6447c357493214f = '#7A869A';
const $4f06f72592355b39$export$f563ee71e9ee74cd = '#6B778C';
const $4f06f72592355b39$export$e2ef2124cf4024b1 = '#5E6C84';
const $4f06f72592355b39$export$eece5f492e429f08 = '#505F79';
const $4f06f72592355b39$export$c39c0fe0f26207ae = '#42526E';
const $4f06f72592355b39$export$7090862dc3038a9f = '#344563';
const $4f06f72592355b39$export$ad0bacf983b7ddaa = '#253858';
const $4f06f72592355b39$export$7d61b15e0da132af = '#172B4D';
const $4f06f72592355b39$export$fbda843f0a27fe96 = '#091E42';
const $4f06f72592355b39$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $4f06f72592355b39$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $4f06f72592355b39$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $4f06f72592355b39$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $4f06f72592355b39$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $4f06f72592355b39$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $4f06f72592355b39$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $4f06f72592355b39$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $4f06f72592355b39$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $4f06f72592355b39$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $4f06f72592355b39$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $4f06f72592355b39$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $4f06f72592355b39$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $4f06f72592355b39$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $4f06f72592355b39$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $4f06f72592355b39$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $4f06f72592355b39$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $4f06f72592355b39$export$2f6319cf7d736c2a = '#E6EDFA';
const $4f06f72592355b39$export$95126bc8884d6634 = '#DCE5F5';
const $4f06f72592355b39$export$8338d8c35d44ff1 = '#CED9EB';
const $4f06f72592355b39$export$5368d76ae4fbbda7 = '#B8C7E0';
const $4f06f72592355b39$export$9f0a771d16ec8d36 = '#ABBBD6';
const $4f06f72592355b39$export$abcf8c38338b4aa5 = '#9FB0CC';
const $4f06f72592355b39$export$97e81faa16a182c7 = '#8C9CB8';
const $4f06f72592355b39$export$bfe21c59123ecf33 = '#7988A3';
const $4f06f72592355b39$export$ee82aa2ea6a1558 = '#67758F';
const $4f06f72592355b39$export$682927c6ed76be02 = '#56637A';
const $4f06f72592355b39$export$91fd9994c5be9757 = '#455166';
const $4f06f72592355b39$export$d281fbfe3cff2df6 = '#3B475C';
const $4f06f72592355b39$export$3902c91d8b98a753 = '#313D52';
const $4f06f72592355b39$export$8e8133c1ba5845b5 = '#283447';
const $4f06f72592355b39$export$33ff357f6620b39 = '#202B3D';
const $4f06f72592355b39$export$633847cf062b69e0 = '#1B2638';
const $4f06f72592355b39$export$9776a6e503bdbf76 = '#121A29';
const $4f06f72592355b39$export$6c813d5160dff5db = '#0E1624';
const $4f06f72592355b39$export$3d4f271a500072a = '#0D1424';
const $4f06f72592355b39$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $4f06f72592355b39$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $4f06f72592355b39$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $4f06f72592355b39$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $4f06f72592355b39$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $4f06f72592355b39$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $4f06f72592355b39$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $4f06f72592355b39$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $4f06f72592355b39$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $4f06f72592355b39$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $4f06f72592355b39$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $4f06f72592355b39$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $4f06f72592355b39$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $4f06f72592355b39$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $4f06f72592355b39$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $4f06f72592355b39$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $4f06f72592355b39$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $4f06f72592355b39$export$d2adc5dedf09fced = '#292A2E';
const $4f06f72592355b39$export$f51762073d2bb381 = '#94C748';
const $4f06f72592355b39$export$95e26d54def96891 = '#B3DF72';

parcelRegister("e8nxS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25255b73c374f1a1c424eeee2ba346f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4a413a5606e695e$var$_react = $a4a413a5606e695e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a4a413a5606e695e$var$_warning = $a4a413a5606e695e$var$_interopRequireDefault((parcelRequire("kLd9o")));

var $a4a413a5606e695e$var$_warning2 = $a4a413a5606e695e$var$_interopRequireDefault((parcelRequire("8QdU3")));
function $a4a413a5606e695e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4a413a5606e695e$var$WarningIcon = (props)=>/*#__PURE__*/ $a4a413a5606e695e$var$_react.default.createElement($a4a413a5606e695e$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $a4a413a5606e695e$var$_warning2.default
    }, props));
$a4a413a5606e695e$var$WarningIcon.Name = 'WarningIconMigration';
var $a4a413a5606e695e$var$_default = module.exports.default = $a4a413a5606e695e$var$WarningIcon;

});

parcelRegister("fbiH2", function(module, exports) {

$parcel$export(module.exports, "NoLinkAppearance", () => $c529dceaa01aa52d$export$afb2f4f410fd9408);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9lAFr = parcelRequire("9lAFr");

var $b7MmR = parcelRequire("b7MmR");

var $iYZCl = parcelRequire("iYZCl");
const $c529dceaa01aa52d$export$afb2f4f410fd9408 = (props)=>(0, $iYZCl.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b7MmR.NoLinkAppearance), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9lAFr.NoLinkAppearance), {
        ...props
    });

});
parcelRegister("9lAFr", function(module, exports) {

$parcel$export(module.exports, "NoLinkAppearance", () => $967728287974c3ea$export$afb2f4f410fd9408);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $967728287974c3ea$export$afb2f4f410fd9408 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e122lsn60"
})({
    color: `var(--ds-text-subtlest, ${(0, $4f06f72592355b39$export$f563ee71e9ee74cd)})`
});

});

parcelRegister("b7MmR", function(module, exports) {

$parcel$export(module.exports, "NoLinkAppearance", () => $9aac3e201bc6e704$export$afb2f4f410fd9408);
/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9aac3e201bc6e704$var$noLinkAppearanceStyles = null;
const $9aac3e201bc6e704$export$afb2f4f410fd9408 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_syaz1wmz"
        ]),
        children: children
    });

});



parcelRegister("jTK8A", function(module, exports) {

$parcel$export(module.exports, "MediaInlineCardLoadedView", () => $d02455187724b824$export$2880973abd87e8a9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $abeia = parcelRequire("abeia");

var $j8xxK = parcelRequire("j8xxK");
class $d02455187724b824$export$2880973abd87e8a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { title: title = '', isSelected: isSelected, onClick: onClick, icon: icon, testId: testId = 'media-inline-card-loaded-view', titlePrefix: titlePrefix, innerRef: innerRef } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abeia.Frame), {
            innerRef: innerRef,
            testId: testId,
            isSelected: isSelected,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j8xxK.IconAndTitleLayout), {
                emoji: titlePrefix,
                icon: icon,
                title: title
            })
        });
    }
}

});

parcelRegister("4Vfxk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $25b69a55a70cbcec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $25b69a55a70cbcec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    click_to_join: {
        id: 'fabric.media.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.media.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    request_access: {
        id: 'fabric.media.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_description: {
        id: 'fabric.media.request_access_description',
        defaultMessage: 'Request access to {context} view this preview.',
        description: 'Allows the user to request access to a product'
    },
    request_access_pending: {
        id: 'fabric.media.request_access_pending',
        defaultMessage: 'Access pending',
        description: 'Allows the user to try an action again with their current account'
    },
    request_access_pending_description: {
        id: 'fabric.media.request_access_pending_description',
        defaultMessage: 'Your access request is pending.',
        description: 'Informs the user that their request to view this content is pending'
    },
    forbidden_description: {
        id: 'fabric.media.forbidden_description',
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access.",
        description: 'Informs the user that they cannot view this content.'
    },
    request_denied_description: {
        id: 'fabric.media.request_denied_description',
        defaultMessage: 'Your access request was denied. Contact the site admin if you still need access.',
        description: 'Informs the user that their request to view this content was denied'
    },
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file'
    },
    failed_to_upload: {
        id: 'fabric.media.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'We show this message when we have an error uploading a file'
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files'
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file'
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload'
    },
    drag_and_drop_your_files_and_folders: {
        id: 'fabric.media.drag_and_drop_your_files_and_folders',
        defaultMessage: 'Drag and drop your files and folders anywhere or',
        description: 'Used to describe the area where the user can drag and drop files AND folders to upload'
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area'
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload'
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that they can search for GIF image files'
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text'
    },
    cant_retrieve_files: {
        id: 'fabric.media.cant_retrieve_files',
        defaultMessage: 'Ouch! We could not retrieve any files',
        description: 'Error message when we can not find any files in dropbox/google drive'
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work'
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.media.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images'
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query'
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images'
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources'
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.media.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.media.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.media.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.media.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    invalid_permissions: {
        id: 'fabric.media.invalid_permissions',
        defaultMessage: 'Restricted link',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.media.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    select_an_avatar: {
        id: 'fabric.media.select_an_avatar',
        defaultMessage: 'Select a default avatar',
        description: 'Shown when the user selects an avatar from a list of avatars'
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar'
    },
    select_an_avatar_from_all_defaults: {
        id: 'fabric.media.select_an_avatar_from_all_defaults',
        defaultMessage: 'Select from all default options',
        description: 'Announced when user is required to select an avatar from the complete list of default options'
    },
    show_more_avatars_btn_label: {
        id: 'fabric.media.show_more_avatars_btn_label',
        defaultMessage: 'Show more',
        description: 'Button label to show more default avatar options'
    },
    or_select_default_avatars: {
        id: 'fabric.media.or_select_default_avatars',
        defaultMessage: 'Upload a photo or select from some default options',
        description: 'Announced when a user is required to select an avatar by uploading an avatar or selecting from default options'
    },
    loading: {
        id: 'fabric.media.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    loading_file: {
        id: 'fabric.media.loading_file',
        defaultMessage: 'Loading file...',
        description: 'Shown when a file is being fetched'
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word'
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo'
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list'
    },
    avatar_picker_back_btn_label: {
        id: 'fabric.media.avatar_picker_back_btn_label',
        defaultMessage: 'Go Back',
        description: 'Button text to navigate back to the previous screen'
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area'
    },
    alt_text: {
        id: 'fabric.media.alt_text_label',
        defaultMessage: 'Alt text',
        description: 'Shown above the alt text field'
    },
    alt_text_description: {
        id: 'fabric.media.alt_text_helper_message',
        defaultMessage: 'How would you describe the selected image to someone with low vision?',
        description: 'Shown below the alt text field'
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url'
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid'
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big'
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it'
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it'
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file'
    },
    couldnt_generate_encrypted_entry_preview: {
        id: 'fabric.media.couldnt_generate_encrypted_entry_preview',
        defaultMessage: "We can't preview encrypted or password protected files.",
        description: 'Error case for when an entry selected is encrypted'
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file'
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.media.not_found_title',
        defaultMessage: "Uh oh. We can't find this link!",
        description: 'Error case for when a provided link is not found'
    },
    not_found_description: {
        id: 'fabric.media.not_found_description',
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file'
    },
    password_protected_pdf: {
        id: 'fabric.media.password_protected_pdf',
        defaultMessage: 'This file is password protected.',
        description: 'Describing that a PDF cannot be viewed because it is protected by password'
    },
    password: {
        id: 'fabric.media.password',
        defaultMessage: 'Password',
        description: 'Description of Password text field.'
    },
    enter_password: {
        id: 'fabric.media.enter_password',
        defaultMessage: 'Enter password',
        description: 'Prompting user to enter the password.'
    },
    incorrect_password: {
        id: 'fabric.media.incorrect_password',
        defaultMessage: 'Incorrect password. Please try again.',
        description: 'Error case for when a wrong password is inputted.'
    },
    submit: {
        id: 'fabric.media.submit',
        defaultMessage: 'Submit',
        description: 'Description for a button to submit the form.'
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users'
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file'
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature'
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this'
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: ''
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: ''
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed'
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action'
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: ''
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor'
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image'
    },
    could_not_load_link: {
        id: 'fabric.media.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: ''
    },
    annotate_tool_arrow: {
        id: 'fabric.media.annotate.tool.arrow',
        defaultMessage: 'Arrow',
        description: ''
    },
    annotate_tool_text: {
        id: 'fabric.media.annotate.tool.text',
        defaultMessage: 'Text',
        description: ''
    },
    annotate_tool_shape: {
        id: 'fabric.media.annotate.tool.shape',
        defaultMessage: 'Shape',
        description: ''
    },
    annotate_tool_brush: {
        id: 'fabric.media.annotate.tool.brush',
        defaultMessage: 'Brush',
        description: ''
    },
    annotate_tool_blur: {
        id: 'fabric.media.annotate.tool.blur',
        defaultMessage: 'Blur',
        description: ''
    },
    annotate_tool_line_thickness: {
        id: 'fabric.media.annotate.tool.line.thickness',
        defaultMessage: 'Line thickness',
        description: ''
    },
    annotate_tool_color: {
        id: 'fabric.media.annotate.tool.color',
        defaultMessage: 'Color',
        description: ''
    },
    annotate_confirmation_close_anyway: {
        id: 'fabric.media.annotate.confirmation.close.anyway',
        defaultMessage: 'Close anyway',
        description: ''
    },
    annotate_confirmation_heading: {
        id: 'fabric.media.annotate.confirmation.heading',
        defaultMessage: 'Unsaved changes',
        description: ''
    },
    annotate_confirmation_content: {
        id: 'fabric.media.annotate.confirmation.content',
        defaultMessage: 'You have some unsaved changes. Are you sure you want to leave?',
        description: ''
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files'
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically'
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert'
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file'
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file'
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file'
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'Play',
        description: ''
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'Pause',
        description: ''
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know they can disable the fullscreen mode'
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know they can enable the fullscreen mode'
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file'
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file'
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_disabled_security_policy: {
        id: 'fabric.media.download_disabled_security_policy',
        defaultMessage: "Download is blocked by your organization's security policy.",
        description: ''
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: ''
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: ''
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: ''
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: ''
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: ''
    },
    archive: {
        id: 'fabric.media.archive',
        defaultMessage: 'archive',
        description: ''
    },
    email: {
        id: 'fabric.media.email',
        defaultMessage: 'email',
        description: ''
    },
    text: {
        id: 'fabric.media.text',
        defaultMessage: 'text',
        description: ''
    },
    displayThumbnail: {
        id: 'fabric.media.display_thumbnail',
        defaultMessage: 'Display thumbnail',
        description: 'Display file with as a thumbnail.'
    },
    search: {
        id: 'fabric.media.search',
        defaultMessage: 'search',
        description: ''
    },
    view: {
        id: 'fabric.media.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.media.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.media.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    changeView: {
        id: 'fabric.media.change_view',
        defaultMessage: 'Change view',
        description: 'In the context of a file, it allows the user to select a different way of displaying the file either as inline or a card'
    },
    playbackSpeed: {
        id: 'fabric.media.playback_speed',
        defaultMessage: 'Playback speed',
        description: 'In the context of a video player, it allows user to switch the speed of the video'
    },
    skipBackward: {
        id: 'fabric.media.skip_backward',
        defaultMessage: 'Back 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time backward.'
    },
    skipForward: {
        id: 'fabric.media.skip_forward',
        defaultMessage: 'Forward 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time forward.'
    },
    sizeOptions: {
        id: 'fabric.media.size_options',
        defaultMessage: 'Size options',
        description: 'A dropdown with buttons that allow to convert an image to an inline or to an image or original size'
    },
    fileDisplayOptions: {
        id: 'fabric.media.file.display_options',
        defaultMessage: 'Display options',
        description: 'A dropdown with buttons that allow to convert between an inline file or a thumbnail file'
    },
    volumeLevelControlAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'volume',
        description: 'In the context of a video player and screen reader. Aria label for volume level control'
    },
    volumeMuteButtonAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'mute',
        description: 'In the context of a video player and screen reader. Aria label for mute button'
    },
    playbackDefaultSpeed: {
        id: 'fabric.media.playback_default_speed',
        defaultMessage: 'Default',
        description: 'In the context of a video player, it is a value of a default playback speed'
    },
    preview: {
        id: 'fabric.media.preview',
        defaultMessage: 'Preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    creating_preview: {
        id: 'fabric.media.creating_preview',
        defaultMessage: 'Creating preview...',
        description: 'Preview is being created for a media card'
    },
    preview_unavailable: {
        id: 'fabric.media.preview_unavailable',
        defaultMessage: 'Preview unavailable',
        description: 'Preview is unavailable for a media card'
    },
    couldnt_load_file: {
        id: 'fabric.media.couldnt_load_file',
        defaultMessage: "We couldn't load the file.",
        description: 'File is rate limited without metadata'
    },
    error_429: {
        id: 'fabric.media.error_429',
        defaultMessage: 'Error 429',
        description: 'Error 429 is thrown'
    },
    close_and_reopen: {
        id: 'fabric.media.close_and_reopen',
        defaultMessage: 'Try closing this file and reopening.',
        description: 'The preview is rate limited'
    },
    viewer_rateLimited: {
        id: 'fabric.media.viewer_rateLimited',
        defaultMessage: `We're having difficulties loading your file.`,
        description: 'Mediaviewer has been rate limited'
    },
    zip_entry_load_fail: {
        id: 'fabric.media.zip_entry_load_failed',
        defaultMessage: `We couldn't load that zip file item to preview`,
        description: 'Zip entry failed to load'
    },
    file_image_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Image {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded image'
    },
    file_video_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Video {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded video'
    },
    file_audio_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Audio {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded audio'
    },
    file_doc_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Document {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded document'
    },
    file_archive_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Archive {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded archive'
    },
    file_unknown_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'File {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded file'
    },
    open_file_in_viewer: {
        id: 'fabric.media.open_file_in_viewer',
        defaultMessage: 'Open {name}',
        description: 'Shown when user focuses on preview to open the full screen viewer of the file with {name}'
    },
    video_seeker_assistive_text_time_value: {
        id: 'fabric.media.video_seeker_assistive_text_time_value',
        defaultMessage: '{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}',
        description: 'Video time seeker information for screen reader users - final format example: 1 hour 12 minutes 13 seconds of 1 hours 16 minutes 1 second. Units are already translated via Intl.NumberFormat'
    },
    video_seeker_label_assistive_text: {
        id: 'fabric.media.video_seeker_label_assistive_text',
        defaultMessage: 'Seek slider',
        description: 'Video time seek slider aria-label'
    },
    abuse_modal_body: {
        id: 'fabric.media.abuse_modal_body',
        defaultMessage: 'For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content',
        description: 'Abuse Modal Body Message'
    },
    abuse_modal_title: {
        id: 'fabric.media.abuse_modal_title',
        defaultMessage: 'Warning',
        description: 'Abuse Modal Title'
    },
    abuse_modal_submit: {
        id: 'fabric.media.abuse_modal_submit',
        defaultMessage: 'Proceed with download',
        description: 'Abuse Modal Submit button caption'
    }
});

});

parcelRegister("hXEj5", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $b88658542c5960ce$export$3ae94a2503e890a1);

var $1jJjP = parcelRequire("1jJjP");
const $b88658542c5960ce$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $b88658542c5960ce$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
const $b88658542c5960ce$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $1jJjP.createLocalizationProvider)(locale, $b88658542c5960ce$export$f34a3540a1aa68e4);
    return $b88658542c5960ce$export$20911720278c41(l10n.formatToParts(timestamp));
};

});
parcelRegister("1jJjP", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $8153523d462c323e$export$ea56ca58f08ffa52);

var $8g116 = parcelRequire("8g116");

var $dSMJa = parcelRequire("dSMJa");

var $hvNQc = parcelRequire("hvNQc");
const $8153523d462c323e$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $8g116.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $dSMJa.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $hvNQc.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $hvNQc.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("8g116", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $8f600279a4c1eb33$export$dca0327c9b9c6498);
const $8f600279a4c1eb33$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("dSMJa", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $5ab658324a6e3f02$export$cfa2ef2687faeda2);

var $jC5S6 = parcelRequire("jC5S6");

var $8g116 = parcelRequire("8g116");
const $5ab658324a6e3f02$var$INVALID_DATE = new Date(NaN);
const $5ab658324a6e3f02$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $5ab658324a6e3f02$var$INVARIANT_DATE = (0, $jC5S6.toDate)($5ab658324a6e3f02$var$INVARIANT);
const $5ab658324a6e3f02$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $5ab658324a6e3f02$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $5ab658324a6e3f02$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $5ab658324a6e3f02$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $5ab658324a6e3f02$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $8g116.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($5ab658324a6e3f02$var$INVARIANT_DATE);
    const shortDate = $5ab658324a6e3f02$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($5ab658324a6e3f02$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $5ab658324a6e3f02$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($5ab658324a6e3f02$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($5ab658324a6e3f02$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($5ab658324a6e3f02$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $5ab658324a6e3f02$var$stripExtras(date).match($5ab658324a6e3f02$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $5ab658324a6e3f02$var$INVALID_DATE;
        const dateParts = $5ab658324a6e3f02$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $jC5S6.normalizeDate)(extractedDate);
        if (!(0, $jC5S6.isValid)(normalizedDate)) return $5ab658324a6e3f02$var$INVALID_DATE;
        return (0, $jC5S6.toDate)(normalizedDate);
    };
};

});
parcelRegister("jC5S6", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $ea5fd86b0cf530f4$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $ea5fd86b0cf530f4$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $ea5fd86b0cf530f4$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $ea5fd86b0cf530f4$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $ea5fd86b0cf530f4$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $ea5fd86b0cf530f4$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $ea5fd86b0cf530f4$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $ea5fd86b0cf530f4$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $ea5fd86b0cf530f4$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $ea5fd86b0cf530f4$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $ea5fd86b0cf530f4$export$fcc71269590ba0a8 = (date)=>{
    const now = $ea5fd86b0cf530f4$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("hvNQc", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $f7a08ff0d49059e9$export$9b7ca29af37c192);
const $f7a08ff0d49059e9$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});



parcelRegister("8LhoW", function(module, exports) {

$parcel$export(module.exports, "MimeTypeIcon", () => $0f6f5d9c15e2b93a$export$875d423332b93b5f);
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hF9uU = parcelRequire("hF9uU");

var $ipkiu = parcelRequire("ipkiu");
var $kgSB2 = parcelRequire("kgSB2");

var $iYZCl = parcelRequire("iYZCl");
const $0f6f5d9c15e2b93a$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $0f6f5d9c15e2b93a$var$iconWrapperStyles = null;
const $0f6f5d9c15e2b93a$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $hF9uU.getMimeIcon)(mimeType, name);
    // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return (0, $iYZCl.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $bwpsq.default)([
                "_1e0c116y",
                $0f6f5d9c15e2b93a$var$iconWrapperStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ipkiu.IconWrapper), {
            "data-testid": testId,
            "data-type": iconInfo.label,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        });
    }
    // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgSB2.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};

});
parcelRegister("hF9uU", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $68ab8f2329744244$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $68ab8f2329744244$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $68ab8f2329744244$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $68ab8f2329744244$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $68ab8f2329744244$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $68ab8f2329744244$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $68ab8f2329744244$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $68ab8f2329744244$export$61a1de0822e2820);

var $dUvZw = parcelRequire("dUvZw");

var $3iln2 = parcelRequire("3iln2");

var $3n3Xm = parcelRequire("3n3Xm");

var $14XAh = parcelRequire("14XAh");

var $cW573 = parcelRequire("cW573");

var $7eELy = parcelRequire("7eELy");

var $INtY5 = parcelRequire("INtY5");

var $02sI5 = parcelRequire("02sI5");

var $jxDCF = parcelRequire("jxDCF");

var $lrOn2 = parcelRequire("lrOn2");

var $2vig2 = parcelRequire("2vig2");

var $ln9Zk = parcelRequire("ln9Zk");

var $aEV0c = parcelRequire("aEV0c");

var $3aEz1 = parcelRequire("3aEz1");

var $8ZWP9 = parcelRequire("8ZWP9");

var $b4dVg = parcelRequire("b4dVg");
function $68ab8f2329744244$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $68ab8f2329744244$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $68ab8f2329744244$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $68ab8f2329744244$export$849633012686f7ee(file)
    };
}
async function $68ab8f2329744244$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $68ab8f2329744244$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $68ab8f2329744244$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $68ab8f2329744244$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $68ab8f2329744244$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $68ab8f2329744244$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $68ab8f2329744244$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dUvZw)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jxDCF)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2vig2)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jxDCF)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lrOn2)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02sI5)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($14XAh)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3aEz1)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3n3Xm)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iln2)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aEV0c)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ln9Zk)))
    }
];
function $68ab8f2329744244$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $68ab8f2329744244$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $b4dVg.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8ZWP9)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cW573)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7eELy)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($INtY5)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("dUvZw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a2095224c2f67b5d$var$_react = $a2095224c2f67b5d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $a2095224c2f67b5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2095224c2f67b5d$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $a2095224c2f67b5d$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a2095224c2f67b5d$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $a2095224c2f67b5d$var$_default = module.exports.default = $a2095224c2f67b5d$var$PdfDocument24Icon;

});

parcelRegister("3iln2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2663a14a1b412808$var$_react = $2663a14a1b412808$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $2663a14a1b412808$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2663a14a1b412808$var$Gif24Icon = (props)=>/*#__PURE__*/ $2663a14a1b412808$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2663a14a1b412808$var$Gif24Icon.displayName = 'Gif24Icon';
var $2663a14a1b412808$var$_default = module.exports.default = $2663a14a1b412808$var$Gif24Icon;

});

parcelRegister("3n3Xm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $274696be9329bb3e$var$_react = $274696be9329bb3e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $274696be9329bb3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $274696be9329bb3e$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $274696be9329bb3e$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$274696be9329bb3e$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $274696be9329bb3e$var$_default = module.exports.default = $274696be9329bb3e$var$PowerpointPresentation24Icon;

});

parcelRegister("14XAh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0c946256e2ebb658$var$_react = $0c946256e2ebb658$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $0c946256e2ebb658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0c946256e2ebb658$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $0c946256e2ebb658$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0c946256e2ebb658$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $0c946256e2ebb658$var$_default = module.exports.default = $0c946256e2ebb658$var$WordDocument24Icon;

});

parcelRegister("cW573", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $96aede19ce6af62c$var$_react = $96aede19ce6af62c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $96aede19ce6af62c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96aede19ce6af62c$var$Sketch24Icon = (props)=>/*#__PURE__*/ $96aede19ce6af62c$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$96aede19ce6af62c$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $96aede19ce6af62c$var$_default = module.exports.default = $96aede19ce6af62c$var$Sketch24Icon;

});

parcelRegister("7eELy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $5449767da435385d$var$_react = $5449767da435385d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $5449767da435385d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5449767da435385d$var$Figma24Icon = (props)=>/*#__PURE__*/ $5449767da435385d$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$5449767da435385d$var$Figma24Icon.displayName = 'Figma24Icon';
var $5449767da435385d$var$_default = module.exports.default = $5449767da435385d$var$Figma24Icon;

});

parcelRegister("INtY5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $086a7e5747684aac$var$_react = $086a7e5747684aac$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $086a7e5747684aac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $086a7e5747684aac$var$Executable24Icon = (props)=>/*#__PURE__*/ $086a7e5747684aac$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$086a7e5747684aac$var$Executable24Icon.displayName = 'Executable24Icon';
var $086a7e5747684aac$var$_default = module.exports.default = $086a7e5747684aac$var$Executable24Icon;

});

parcelRegister("02sI5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $00767543f498267b$var$_react = $00767543f498267b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $00767543f498267b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00767543f498267b$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $00767543f498267b$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$00767543f498267b$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $00767543f498267b$var$_default = module.exports.default = $00767543f498267b$var$GoogleDoc24Icon;

});

parcelRegister("jxDCF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e39fd5a427c4ac53$var$_react = $e39fd5a427c4ac53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $e39fd5a427c4ac53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e39fd5a427c4ac53$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $e39fd5a427c4ac53$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e39fd5a427c4ac53$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $e39fd5a427c4ac53$var$_default = module.exports.default = $e39fd5a427c4ac53$var$GoogleForm24Icon;

});

parcelRegister("lrOn2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f9d331278c0ac244$var$_react = $f9d331278c0ac244$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $f9d331278c0ac244$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9d331278c0ac244$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $f9d331278c0ac244$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f9d331278c0ac244$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $f9d331278c0ac244$var$_default = module.exports.default = $f9d331278c0ac244$var$GoogleSheet24Icon;

});

parcelRegister("2vig2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1d2ca3a03af5938a$var$_react = $1d2ca3a03af5938a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $1d2ca3a03af5938a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1d2ca3a03af5938a$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1d2ca3a03af5938a$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1d2ca3a03af5938a$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1d2ca3a03af5938a$var$_default = module.exports.default = $1d2ca3a03af5938a$var$GoogleSlide24Icon;

});

parcelRegister("ln9Zk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8f37e64630daeb9$var$_react = $f8f37e64630daeb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $f8f37e64630daeb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8f37e64630daeb9$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $f8f37e64630daeb9$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8f37e64630daeb9$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $f8f37e64630daeb9$var$_default = module.exports.default = $f8f37e64630daeb9$var$ExcelSpreadsheet24Icon;

});

parcelRegister("aEV0c", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7c29db4430657fb7$var$_react = $7c29db4430657fb7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $7c29db4430657fb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7c29db4430657fb7$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $7c29db4430657fb7$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7c29db4430657fb7$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $7c29db4430657fb7$var$_default = module.exports.default = $7c29db4430657fb7$var$Spreadsheet24Icon;

});

parcelRegister("3aEz1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $24f1c56e8459cee1$var$_react = $24f1c56e8459cee1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $24f1c56e8459cee1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $24f1c56e8459cee1$var$Presentation24Icon = (props)=>/*#__PURE__*/ $24f1c56e8459cee1$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$24f1c56e8459cee1$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $24f1c56e8459cee1$var$_default = module.exports.default = $24f1c56e8459cee1$var$Presentation24Icon;

});

parcelRegister("8ZWP9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68d1a670d3f05d17$var$_react = $68d1a670d3f05d17$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $68d1a670d3f05d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68d1a670d3f05d17$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $68d1a670d3f05d17$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$68d1a670d3f05d17$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $68d1a670d3f05d17$var$_default = module.exports.default = $68d1a670d3f05d17$var$SourceCode24Icon;

});

parcelRegister("b4dVg", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $847c8209fddb922d$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $847c8209fddb922d$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $847c8209fddb922d$export$ba4368c844580f9e);
function $847c8209fddb922d$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $847c8209fddb922d$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $847c8209fddb922d$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $847c8209fddb922d$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $847c8209fddb922d$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $847c8209fddb922d$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $847c8209fddb922d$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("ipkiu", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $36b3fb252d825722$export$be58b4326e23250f);
$parcel$export(module.exports, "MediaTypeIcon", () => $36b3fb252d825722$export$3787195047fd197b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7gZmX = parcelRequire("7gZmX");

var $bwhYD = parcelRequire("bwhYD");

var $jRd2L = parcelRequire("jRd2L");

var $eKHMN = parcelRequire("eKHMN");

var $g6Jmp = parcelRequire("g6Jmp");

var $2sXwF = parcelRequire("2sXwF");

var $4cgFj = parcelRequire("4cgFj");

var $9TCUW = parcelRequire("9TCUW");

var $4mqEe = parcelRequire("4mqEe");

var $cCqI0 = parcelRequire("cCqI0");

var $fahVC = parcelRequire("fahVC");

var $hsngw = parcelRequire("hsngw");

var $bWGt6 = parcelRequire("bWGt6");
const $36b3fb252d825722$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "exhtxam0"
})("display:inline-flex;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ size: size })=>size === 'large' ? `padding: 4px;` : '');
$36b3fb252d825722$export$be58b4326e23250f.displayName = 'IconWrapper';
const $36b3fb252d825722$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($7gZmX))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($bwhYD))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($jRd2L))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($eKHMN))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($g6Jmp))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($2sXwF)))
};
const $36b3fb252d825722$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($4cgFj))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($9TCUW))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($4mqEe))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($cCqI0))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($fahVC))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($hsngw)))
};
const $36b3fb252d825722$var$defaultType = 'unknown';
class $36b3fb252d825722$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            type: $36b3fb252d825722$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $36b3fb252d825722$var$defaultType;
        const icons = size === 'large' ? $36b3fb252d825722$var$largeIcons : $36b3fb252d825722$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$36b3fb252d825722$var$defaultType];
        return /*#__PURE__*/ (0, $2OMIu.jsx)($36b3fb252d825722$export$be58b4326e23250f, {
            "data-testid": testId,
            "data-type": type,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});
parcelRegister("7gZmX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54b9a1b406a138ac$var$_react = $54b9a1b406a138ac$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $54b9a1b406a138ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54b9a1b406a138ac$var$Image24Icon = (props)=>/*#__PURE__*/ $54b9a1b406a138ac$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54b9a1b406a138ac$var$Image24Icon.displayName = 'Image24Icon';
var $54b9a1b406a138ac$var$_default = module.exports.default = $54b9a1b406a138ac$var$Image24Icon;

});

parcelRegister("bwhYD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8630a0b6e230279d$var$_react = $8630a0b6e230279d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $8630a0b6e230279d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8630a0b6e230279d$var$Audio24Icon = (props)=>/*#__PURE__*/ $8630a0b6e230279d$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8630a0b6e230279d$var$Audio24Icon.displayName = 'Audio24Icon';
var $8630a0b6e230279d$var$_default = module.exports.default = $8630a0b6e230279d$var$Audio24Icon;

});

parcelRegister("jRd2L", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e74d15bf12d19108$var$_react = $e74d15bf12d19108$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $e74d15bf12d19108$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e74d15bf12d19108$var$Video24Icon = (props)=>/*#__PURE__*/ $e74d15bf12d19108$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e74d15bf12d19108$var$Video24Icon.displayName = 'Video24Icon';
var $e74d15bf12d19108$var$_default = module.exports.default = $e74d15bf12d19108$var$Video24Icon;

});

parcelRegister("eKHMN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $abd7538d3829e404$var$_react = $abd7538d3829e404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $abd7538d3829e404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abd7538d3829e404$var$Document24Icon = (props)=>/*#__PURE__*/ $abd7538d3829e404$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$abd7538d3829e404$var$Document24Icon.displayName = 'Document24Icon';
var $abd7538d3829e404$var$_default = module.exports.default = $abd7538d3829e404$var$Document24Icon;

});

parcelRegister("g6Jmp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bba064854b6714fb$var$_react = $bba064854b6714fb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $bba064854b6714fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bba064854b6714fb$var$Archive24Icon = (props)=>/*#__PURE__*/ $bba064854b6714fb$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bba064854b6714fb$var$Archive24Icon.displayName = 'Archive24Icon';
var $bba064854b6714fb$var$_default = module.exports.default = $bba064854b6714fb$var$Archive24Icon;

});

parcelRegister("2sXwF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1cbc5ee249f92d0b$var$_react = $1cbc5ee249f92d0b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $1cbc5ee249f92d0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1cbc5ee249f92d0b$var$Generic24Icon = (props)=>/*#__PURE__*/ $1cbc5ee249f92d0b$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1cbc5ee249f92d0b$var$Generic24Icon.displayName = 'Generic24Icon';
var $1cbc5ee249f92d0b$var$_default = module.exports.default = $1cbc5ee249f92d0b$var$Generic24Icon;

});

parcelRegister("4cgFj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $30e535d145e0c97f$var$_react = $30e535d145e0c97f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $30e535d145e0c97f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $30e535d145e0c97f$var$Image16Icon = (props)=>/*#__PURE__*/ $30e535d145e0c97f$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$30e535d145e0c97f$var$Image16Icon.displayName = 'Image16Icon';
var $30e535d145e0c97f$var$_default = module.exports.default = $30e535d145e0c97f$var$Image16Icon;

});

parcelRegister("9TCUW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73477051a4fe7ac5$var$_react = $73477051a4fe7ac5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $73477051a4fe7ac5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73477051a4fe7ac5$var$Audio16Icon = (props)=>/*#__PURE__*/ $73477051a4fe7ac5$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$73477051a4fe7ac5$var$Audio16Icon.displayName = 'Audio16Icon';
var $73477051a4fe7ac5$var$_default = module.exports.default = $73477051a4fe7ac5$var$Audio16Icon;

});

parcelRegister("4mqEe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $32cde337cb9f97e8$var$_react = $32cde337cb9f97e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $32cde337cb9f97e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32cde337cb9f97e8$var$Video16Icon = (props)=>/*#__PURE__*/ $32cde337cb9f97e8$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$32cde337cb9f97e8$var$Video16Icon.displayName = 'Video16Icon';
var $32cde337cb9f97e8$var$_default = module.exports.default = $32cde337cb9f97e8$var$Video16Icon;

});

parcelRegister("cCqI0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $92fdc07495342154$var$_react = $92fdc07495342154$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $92fdc07495342154$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $92fdc07495342154$var$Document16Icon = (props)=>/*#__PURE__*/ $92fdc07495342154$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$92fdc07495342154$var$Document16Icon.displayName = 'Document16Icon';
var $92fdc07495342154$var$_default = module.exports.default = $92fdc07495342154$var$Document16Icon;

});

parcelRegister("fahVC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $b0a5b25e833526a4$var$_react = $b0a5b25e833526a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $b0a5b25e833526a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b0a5b25e833526a4$var$Archive16Icon = (props)=>/*#__PURE__*/ $b0a5b25e833526a4$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$b0a5b25e833526a4$var$Archive16Icon.displayName = 'Archive16Icon';
var $b0a5b25e833526a4$var$_default = module.exports.default = $b0a5b25e833526a4$var$Archive16Icon;

});

parcelRegister("hsngw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cb571939f4dceb22$var$_react = $cb571939f4dceb22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aZfhv = parcelRequire("aZfhv");
function $cb571939f4dceb22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cb571939f4dceb22$var$Generic16Icon = (props)=>/*#__PURE__*/ $cb571939f4dceb22$var$_react.default.createElement($aZfhv.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cb571939f4dceb22$var$Generic16Icon.displayName = 'Generic16Icon';
var $cb571939f4dceb22$var$_default = module.exports.default = $cb571939f4dceb22$var$Generic16Icon;

});


parcelRegister("kgSB2", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $455c66a285026906$export$3787195047fd197b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ipkiu = parcelRequire("ipkiu");

var $jsz2L = parcelRequire("jsz2L");

var $iYZCl = parcelRequire("iYZCl");
class $455c66a285026906$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return (0, $iYZCl.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jsz2L.MediaTypeIcon), {
            ...this.props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ipkiu.MediaTypeIcon), {
            ...this.props
        });
    }
}

});
parcelRegister("jsz2L", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $8d3acd973cf2e755$export$3787195047fd197b);
/* media-type-icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7gZmX = parcelRequire("7gZmX");

var $bwhYD = parcelRequire("bwhYD");

var $jRd2L = parcelRequire("jRd2L");

var $eKHMN = parcelRequire("eKHMN");

var $g6Jmp = parcelRequire("g6Jmp");

var $2sXwF = parcelRequire("2sXwF");

var $4cgFj = parcelRequire("4cgFj");

var $9TCUW = parcelRequire("9TCUW");

var $4mqEe = parcelRequire("4mqEe");

var $cCqI0 = parcelRequire("cCqI0");

var $fahVC = parcelRequire("fahVC");

var $hsngw = parcelRequire("hsngw");
const $8d3acd973cf2e755$var$iconStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $8d3acd973cf2e755$var$iconStyles = null;
const $8d3acd973cf2e755$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($7gZmX))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($bwhYD))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($jRd2L))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($eKHMN))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($g6Jmp))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($2sXwF)))
};
const $8d3acd973cf2e755$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($4cgFj))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($9TCUW))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($4mqEe))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($cCqI0))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($fahVC))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($hsngw)))
};
const $8d3acd973cf2e755$var$defaultType = 'unknown';
class $8d3acd973cf2e755$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            type: $8d3acd973cf2e755$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $8d3acd973cf2e755$var$defaultType;
        const icons = size === 'large' ? $8d3acd973cf2e755$var$largeIcons : $8d3acd973cf2e755$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$8d3acd973cf2e755$var$defaultType];
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-testid": testId,
            "data-type": type,
            className: (0, $bwpsq.default)([
                "_1e0c116y",
                $8d3acd973cf2e755$var$iconStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});



parcelRegister("bdHts", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c4e7b097d65d53$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3swLe = parcelRequire("3swLe");

var $gLvGA = parcelRequire("gLvGA");

const $19c4e7b097d65d53$var$MediaViewer = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("i7R9m")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $19c4e7b097d65d53$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3swLe.default), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gLvGA.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($19c4e7b097d65d53$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("3swLe", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $2915f2a68f0863d4$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $2915f2a68f0863d4$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fhpJw = parcelRequire("fhpJw");

var $eUVMD = parcelRequire("eUVMD");
const $2915f2a68f0863d4$export$442b7be89436c101 = '#101214';
const $2915f2a68f0863d4$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $eUVMD.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fhpJw.default), {
        blankedColor: $2915f2a68f0863d4$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $2915f2a68f0863d4$export$2e2bcd8739ae039 = $2915f2a68f0863d4$var$ModalSpinner;

});
parcelRegister("fhpJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef26e21c2600cc1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9VWZn = parcelRequire("9VWZn");

var $5Vtm0 = parcelRequire("5Vtm0");

var $iYZCl = parcelRequire("iYZCl");
const $3ef26e21c2600cc1$var$ModalSpinner = (props)=>(0, $iYZCl.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Vtm0.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VWZn.default), {
        ...props
    });
var $3ef26e21c2600cc1$export$2e2bcd8739ae039 = $3ef26e21c2600cc1$var$ModalSpinner;

});
parcelRegister("9VWZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d174802acaf6157$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2pYBE = parcelRequire("2pYBE");

var $3SeOJ = parcelRequire("3SeOJ");

var $bWGt6 = parcelRequire("bWGt6");
function $5d174802acaf6157$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5d174802acaf6157$var$overlayZindex = (0, $2pYBE.layers).modal() + 10;
const $5d174802acaf6157$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $5d174802acaf6157$var$overlayZindex
});
$5d174802acaf6157$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $5d174802acaf6157$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$5d174802acaf6157$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $5d174802acaf6157$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $5d174802acaf6157$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)($5d174802acaf6157$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $5d174802acaf6157$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5d174802acaf6157$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SeOJ.default), {
                size: "large",
                appearance: invertSpinnerColor || $5d174802acaf6157$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("5Vtm0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6743be58622ae505$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3SeOJ = parcelRequire("3SeOJ");
const $6743be58622ae505$var$blanketStyles = null;
const $6743be58622ae505$var$spinnerStyles = null;
const $6743be58622ae505$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $6743be58622ae505$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $6743be58622ae505$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3SeOJ.default), {
                size: "large",
                appearance: invertSpinnerColor || $6743be58622ae505$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("gLvGA", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $adb1d1a4ec587d71$export$51aee4c01b17acde);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1U8OB = parcelRequire("1U8OB");
const $adb1d1a4ec587d71$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1U8OB.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("i7R9m", function(module, exports) {

let $d3221bec8f8931ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d3221bec8f8931ea$var$load("cM9em"),
    $d3221bec8f8931ea$var$load("fr9NE"),
    $d3221bec8f8931ea$var$load("h2MrD"),
    $d3221bec8f8931ea$var$load("bYT2S"),
    $d3221bec8f8931ea$var$load("gjHDp")
]).then(()=>parcelRequire('98j27'));

});


parcelRegister("kAmKx", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $9385a5cb9e202b67$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $9385a5cb9e202b67$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $9385a5cb9e202b67$export$11f9f5835c5b9a04);
class $9385a5cb9e202b67$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $9385a5cb9e202b67$export$2c035820a31723e extends $9385a5cb9e202b67$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $9385a5cb9e202b67$export$10ab445310d30114 extends $9385a5cb9e202b67$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $9385a5cb9e202b67$export$18e89b7e50818288 extends $9385a5cb9e202b67$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $9385a5cb9e202b67$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $9385a5cb9e202b67$export$d0a45ab59b4606b extends $9385a5cb9e202b67$export$ec8d022824f41295 {
    constructor(source){
        super($9385a5cb9e202b67$export$921ab4548acefaa4(source));
    }
}
function $9385a5cb9e202b67$export$36b43e3dd9a92(err) {
    return err instanceof $9385a5cb9e202b67$export$ec8d022824f41295;
}
const $9385a5cb9e202b67$export$b380593ba3516c6f = (err)=>err instanceof $9385a5cb9e202b67$export$2c035820a31723e;
const $9385a5cb9e202b67$export$e1d87830b3784f94 = (err)=>err instanceof $9385a5cb9e202b67$export$10ab445310d30114;
const $9385a5cb9e202b67$export$443aeb298d35d79d = (err)=>$9385a5cb9e202b67$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $9385a5cb9e202b67$export$f00bb5a138da22e1(err) {
    return err instanceof $9385a5cb9e202b67$export$d0a45ab59b4606b;
}
const $9385a5cb9e202b67$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($9385a5cb9e202b67$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $9385a5cb9e202b67$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $9385a5cb9e202b67$export$ec8d022824f41295(primaryReason, error);
};
const $9385a5cb9e202b67$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});

parcelRegister("84J7p", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $dc7324564f1d1c70$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $dc7324564f1d1c70$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $dc7324564f1d1c70$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $dc7324564f1d1c70$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $dc7324564f1d1c70$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $dc7324564f1d1c70$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $dc7324564f1d1c70$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $dc7324564f1d1c70$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $dc7324564f1d1c70$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $dc7324564f1d1c70$export$4d33ada3618f7626);

var $iviFJ = parcelRequire("iviFJ");

var $3nBUx = parcelRequire("3nBUx");

var $38BgC = parcelRequire("38BgC");
const $dc7324564f1d1c70$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $dc7324564f1d1c70$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $dc7324564f1d1c70$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $dc7324564f1d1c70$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $dc7324564f1d1c70$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $dc7324564f1d1c70$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $dc7324564f1d1c70$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $dc7324564f1d1c70$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $iviFJ.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $dc7324564f1d1c70$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $iviFJ.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $dc7324564f1d1c70$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $iviFJ.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $dc7324564f1d1c70$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $iviFJ.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $dc7324564f1d1c70$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $dc7324564f1d1c70$export$4af9d71992e89714(error),
        error: $dc7324564f1d1c70$export$88c61dcad53762da(error),
        errorDetail: $dc7324564f1d1c70$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $dc7324564f1d1c70$export$29aa614726672b2e(error)
    };
};
const $dc7324564f1d1c70$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$dc7324564f1d1c70$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $dc7324564f1d1c70$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $dc7324564f1d1c70$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$dc7324564f1d1c70$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $dc7324564f1d1c70$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $dc7324564f1d1c70$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$dc7324564f1d1c70$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $dc7324564f1d1c70$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $dc7324564f1d1c70$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $dc7324564f1d1c70$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $3nBUx.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $73f48989c0fb2410$export$ec1779cb96554e1));
    }
}
const $dc7324564f1d1c70$export$4d33ada3618f7626 = (payload)=>{
    return (0, $38BgC.default)((0, $73f48989c0fb2410$export$ec1779cb96554e1))((0, $3nBUx.sanitiseAnalyticsPayload)(payload));
};

});
const $73f48989c0fb2410$export$ec1779cb96554e1 = 'media';

parcelRegister("3nBUx", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $d009c83b6d437be0$export$e24d38cbdf73bc1a);

var $6CZ6k = parcelRequire("6CZ6k");

var $86xFr = parcelRequire("86xFr");
const $d009c83b6d437be0$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $d009c83b6d437be0$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $d009c83b6d437be0$export$e24d38cbdf73bc1a = (payload)=>$d009c83b6d437be0$var$hasFileAttributesWithFileId(payload) ? (0, $86xFr.produce)(payload, $d009c83b6d437be0$var$sanitiseFileId) : payload;

});


parcelRegister("8BpTo", function(module, exports) {

$parcel$export(module.exports, "getSucceededStatusPayload", () => $ff10a8baad77d9e7$export$95e48cf5f4b392a4);
$parcel$export(module.exports, "getErrorStatusPayload", () => $ff10a8baad77d9e7$export$b37f976ad373d2e0);
$parcel$export(module.exports, "getFailedProcessingStatusPayload", () => $ff10a8baad77d9e7$export$d0b5daf3b6a26055);
$parcel$export(module.exports, "fireFailedOperationalEvent", () => $ff10a8baad77d9e7$export$d66a74eca3334206);
$parcel$export(module.exports, "fireSucceededOperationalEvent", () => $ff10a8baad77d9e7$export$3bc90882cb04fda4);

var $84J7p = parcelRequire("84J7p");

var $kAmKx = parcelRequire("kAmKx");
const $ff10a8baad77d9e7$export$95e48cf5f4b392a4 = (fileState)=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'success',
            fileAttributes: {
                fileId: fileState?.id || '',
                fileSize: fileState?.size,
                fileMediatype: fileState?.mediaType,
                fileMimetype: fileState?.mimeType,
                fileStatus: fileState?.status
            }
        }
    };
};
const $ff10a8baad77d9e7$export$b37f976ad373d2e0 = (fileId, error, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            ...(0, $84J7p.extractErrorInfo)(error)
        }
    };
};
const $ff10a8baad77d9e7$export$d0b5daf3b6a26055 = (fileId, fileState)=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaInlineRender',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId,
                fileStatus: fileState?.status
            },
            failReason: 'failed-processing'
        }
    };
};
const $ff10a8baad77d9e7$export$d66a74eca3334206 = (fileState, error = new (0, $kAmKx.MediaCardError)('missing-error-data'), failReason, createAnalyticsEvent)=>{
    const payload = failReason ? $ff10a8baad77d9e7$export$d0b5daf3b6a26055(fileState?.id || 'unknown-id', fileState) : $ff10a8baad77d9e7$export$b37f976ad373d2e0(fileState?.id || 'unknown-id', error, fileState);
    (0, $84J7p.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $ff10a8baad77d9e7$export$3bc90882cb04fda4 = (fileState, createAnalyticsEvent)=>{
    const payload = $ff10a8baad77d9e7$export$95e48cf5f4b392a4(fileState);
    (0, $84J7p.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});

parcelRegister("EEbRM", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $4af0cd0b0ab6f18a$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $12d8n = parcelRequire("12d8n");

var $iYZCl = parcelRequire("iYZCl");

var $kl6Sh = parcelRequire("kl6Sh");

var $9mcJj = parcelRequire("9mcJj");

var $hJkIM = parcelRequire("hJkIM");
function $4af0cd0b0ab6f18a$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $4af0cd0b0ab6f18a$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $kl6Sh.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const registerCopyIntentRef = $4af0cd0b0ab6f18a$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $9mcJj.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $9mcJj.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $iYZCl.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $iYZCl.fg)('platform_media_cross_client_copy')) (0, $hJkIM.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $hJkIM.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("9mcJj", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $7fa88b645571ebdd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $7fa88b645571ebdd$export$aacb463551da2e8f);

var $9e8JJ = parcelRequire("9e8JJ");
const $7fa88b645571ebdd$var$getRequestErrorDetails = (err)=>{
    if ((0, $9e8JJ.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $7fa88b645571ebdd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $9e8JJ.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$7fa88b645571ebdd$var$getRequestErrorDetails(error)
        }
    };
};
const $7fa88b645571ebdd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("hJkIM", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $e00c9e42a59be4e0$export$f65ca476c09acec0);
const $e00c9e42a59be4e0$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




//# sourceMappingURL=@atlaskit-internal_inline-media-card.12deea45.js.map
